import { Injectable } from '@angular/core';

import { BonusText } from '@app/shared/shared.models';
import { BaseService } from '@app/shared/shared.service';

@Injectable()
export class WigSummaryService extends BaseService {
  getBonusText(name: string): Promise<BonusText> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<BonusText>(
        this.serviceUrl + `/configuration/bonusinformation?name=${name}`,
        requestOptions
      )
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/safeandontime/api/v1';
  }
}
